import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import './SelectedComparableColumns.scss';

SelectedComparableColumns.propTypes = {
  column1: PropTypes.node.isRequired,
  column2: PropTypes.node.isRequired,
  column3: PropTypes.node.isRequired,
  column4: PropTypes.node.isRequired,
  column5: PropTypes.node.isRequired,
  column6: PropTypes.node.isRequired,
  column7: PropTypes.node.isRequired,
  onFeaturedClick: PropTypes.func,
};

export default function SelectedComparableColumns({
  column1,
  column2,
  column3,
  column4,
  column5,
  column6,
  column7,
  onFeaturedClick,
}) {
  return (
    <Grid container spacing={4}>
      <Grid className="column1" size={4}>{column1}</Grid>
      <Grid className="column2" size={1} onClick={onFeaturedClick}>{column2}</Grid>
      <Grid className="column3" size={1}>{column3}</Grid>
      <Grid className="column4" size={1.7}>{column4}</Grid>
      <Grid className="column5" size={1.1}>{column5}</Grid>
      <Grid className="column6" size={1}>{column6}</Grid>
      <Grid className="column7" size={2.2}>{column7}</Grid>
    </Grid>
  );
}
